import React from 'react';
import { Link } from 'react-router-dom';
import { usePageTitle } from '../hooks/usePageTitle';
import './Services.css';

function Services() {
  usePageTitle('Services');
  return (
    <div className="services">
      <section className="services-hero">
        <div className="services-container">
          <h1 className="services-hero-title">Our Services</h1>
          <p className="services-hero-subtitle">Comprehensive AI and software engineering solutions to transform your business</p>
        </div>
      </section>

      <section className="services-main">
        <div className="services-container">
          <div className="service-item">
            <div className="service-icon">🤖</div>
            <div className="service-content">
              <h2>AI Development</h2>
              <p>Build intelligent systems powered by machine learning, natural language processing, and computer vision. We create custom AI solutions that solve real business problems and deliver measurable ROI.</p>
              <ul>
                <li>Custom AI model development and training</li>
                <li>LLM integration and fine-tuning</li>
                <li>Predictive analytics and forecasting</li>
                <li>AI strategy and consulting</li>
              </ul>
            </div>
          </div>

          <div className="service-item">
            <div className="service-icon">✨</div>
            <div className="service-content">
              <h2>Generative AI Solutions</h2>
              <p>Leverage the power of GPT, Claude, and other foundation models to automate content creation, customer service, and knowledge management.</p>
              <ul>
                <li>RAG (Retrieval Augmented Generation) systems</li>
                <li>Custom GPT applications</li>
                <li>AI content generation platforms</li>
                <li>Intelligent document processing</li>
              </ul>
            </div>
          </div>

          <div className="service-item">
            <div className="service-icon">👁️</div>
            <div className="service-content">
              <h2>Computer Vision</h2>
              <p>Deploy AI-powered visual intelligence for quality control, surveillance, and automated inspection systems.</p>
              <ul>
                <li>Defect detection in manufacturing</li>
                <li>Object detection and tracking</li>
                <li>Facial recognition systems</li>
                <li>Medical image analysis</li>
              </ul>
            </div>
          </div>

          <div className="service-item">
            <div className="service-icon">💬</div>
            <div className="service-content">
              <h2>Conversational AI & Voice Agents</h2>
              <p>Create intelligent chatbots, voice assistants, and AI avatars that provide human-like interactions at scale.</p>
              <ul>
                <li>AI customer support agents</li>
                <li>Voice-enabled AI assistants</li>
                <li>Video avatar integration</li>
                <li>Multi-language support</li>
              </ul>
            </div>
          </div>

          <div className="service-item">
            <div className="service-icon">💻</div>
            <div className="service-content">
              <h2>Custom Software Development</h2>
              <p>Full-stack web and mobile application development using modern frameworks and best practices.</p>
              <ul>
                <li>React, Angular, Vue.js web apps</li>
                <li>Node.js, Python, Java backends</li>
                <li>React Native, Flutter mobile apps</li>
                <li>API development and integration</li>
              </ul>
            </div>
          </div>

          <div className="service-item">
            <div className="service-icon">☁️</div>
            <div className="service-content">
              <h2>Cloud & DevOps</h2>
              <p>Scalable cloud infrastructure, CI/CD pipelines, and automated deployment systems.</p>
              <ul>
                <li>AWS, Azure, GCP cloud architecture</li>
                <li>Kubernetes and Docker containerization</li>
                <li>CI/CD pipeline setup</li>
                <li>Infrastructure as Code (Terraform)</li>
              </ul>
            </div>
          </div>

          <div className="service-item">
            <div className="service-icon">👥</div>
            <div className="service-content">
              <h2>Engineering Staffing & Dedicated Teams</h2>
              <p>Scale your engineering capacity with our remote developers who integrate seamlessly with your team.</p>
              <ul>
                <li>Staff augmentation</li>
                <li>Dedicated development teams</li>
                <li>AI/ML engineers</li>
                <li>Full-stack developers</li>
              </ul>
              <Link to="/staffing" className="service-link">Learn More About Staffing →</Link>
            </div>
          </div>
        </div>
      </section>

      <section className="services-process">
        <div className="services-container">
          <h2 className="section-title">Our Process</h2>
          <div className="process-grid">
            <div className="process-step">
              <div className="step-number">01</div>
              <h3>Discover</h3>
              <p>Understand your business goals, challenges, and technical requirements</p>
            </div>
            <div className="process-step">
              <div className="step-number">02</div>
              <h3>Design</h3>
              <p>Create architecture, wireframes, and technical specifications</p>
            </div>
            <div className="process-step">
              <div className="step-number">03</div>
              <h3>Build</h3>
              <p>Agile development with bi-weekly sprints and continuous feedback</p>
            </div>
            <div className="process-step">
              <div className="step-number">04</div>
              <h3>Deploy</h3>
              <p>Launch to production with proper testing and monitoring</p>
            </div>
            <div className="process-step">
              <div className="step-number">05</div>
              <h3>Support</h3>
              <p>Ongoing maintenance, bug fixes, and feature enhancements</p>
            </div>
            <div className="process-step">
              <div className="step-number">06</div>
              <h3>Scale</h3>
              <p>Optimize performance and add new capabilities as you grow</p>
            </div>
          </div>
        </div>
      </section>

      <section className="services-cta">
        <div className="services-container">
          <div className="cta-box">
            <h2>Ready to Start Your Project?</h2>
            <p>Let's discuss how we can help you build intelligent software solutions</p>
            <Link to="/contact" className="btn-primary">Get Started</Link>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Services;
